import EDList from '../../../../../../../BaseComponents/List/EDList';
import EDDialog from '../../../../../../../BaseComponents/Dialog/EDDialog';
import EDListItem from '../../../../../../../BaseComponents/List/Components/EDListItem';
import mergeSort, { stringCompare } from '../../../../../../../Utils/mergeSort';
import { IOverlappedBooking } from '../../AktivitetResursValjare';
import { uniq } from 'ramda';
import { formatDateAndTimeInterval } from '../../Utils/AktivitetDateTimeFormatter';
import EDIcon from '../../../../../../../BaseComponents/Icon/EDIcon';
import EDTypography from '../../../../../../../BaseComponents/Typography/EDTypography';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';

interface IProps {
  open: 'save' | 'saveAndClose' | null;
  overlappedBookings: IOverlappedBooking[];
  onClose: (yes: boolean) => void;
  classes?: any;
}

const styles = (_theme: Theme) => ({
  dialogHeaderTopArea: {
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
});

const DubbelbokningsvarningDialogUnstyled = (props: IProps) => {
  const overlappedResources = uniq(
    props.overlappedBookings.map(b => b.resourceName)
  );
  const overlappedBookings = mergeSort(props.overlappedBookings, (a, b) => {
    let compare =
      props.overlappedBookings.findIndex(
        c => c.resourceName === a.resourceName
      ) -
      props.overlappedBookings.findIndex(
        c => c.resourceName === b.resourceName
      );
    if (compare === 0) {
      compare = stringCompare(a.resStart, b.resStart);
    }
    return compare;
  });

  return (
    <EDDialog
      title="Dubbelbokning"
      headerProps={{
        headerIcon: (
          <EDIcon
            marginRight={3}
            iconType="warning"
            color="warning"
            size="large"
          />
        ),
        classes: {
          topArea: props.classes.dialogHeaderTopArea,
        } as any,
      }}
      disableHeader={false}
      open={Boolean(props.open)}
      onClose={() => props.onClose(false)}
      footerActions={[
        {
          label: 'Avbryt',
          onClick: () => {
            props.onClose(false);
          },
        },
        {
          label: 'Ja, dubbelboka',
          onClick: () => {
            props.onClose(true);
          },
        },
      ]}
      maxWidth={false}
      testId={'doubleBookingWarningDialog'}
    >
      <EDTypography variant="body2">Vill du dubbelboka:</EDTypography>
      <EDList>
        {overlappedResources.map((resourceName, index) => (
          <>
            <EDListItem key={index * 1000} leftPadding={'none'}>
              <span>
                <strong>{resourceName}</strong> med:
              </span>
            </EDListItem>
            {overlappedBookings
              .filter(booking => booking.resourceName === resourceName)
              .map((booking, index2) => (
                <EDListItem key={index * 1000 + index2 + 1} topPadding={'none'}>
                  {`${booking.aktTitel}, ${
                    booking.bokNr === '' ? 'outlook' : `boknr: ${booking.bokNr}`
                  }, ${formatDateAndTimeInterval(
                    booking.resStart,
                    booking.resEnd
                  )}`}
                </EDListItem>
              ))}
          </>
        ))}
      </EDList>
    </EDDialog>
  );
};

export const DubbelbokningsvarningDialog = withStyles(
  DubbelbokningsvarningDialogUnstyled,
  styles
);
